import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { localStorageGetItem } from '@utils/localStorage';

const allLangs = [
  {
    label: '한국어',
    value: 'ko',
  },
  {
    label: 'English',
    value: 'en',
  },
];

const defaultLang = allLangs[0];

export default function useLocales() {
  const { t, i18n } = useTranslation();

  const langStorage = localStorageGetItem('i18nextLng');

  const currentLang =
    allLangs.find((lang) => lang.value === langStorage) || defaultLang;

  const onChangeLang = useCallback(
    (newlang: string) => {
      i18n.changeLanguage(newlang);
    },
    [i18n],
  );

  return {
    allLangs,
    t,
    currentLang,
    onChangeLang,
  };
}
